import { AxiosRequestConfig } from 'utils/gql/axios/AxiosClient';
import { captureSentryMessage } from 'integrations/sentry/sentry';
import { apolloGql } from 'utils/gql/apollo/apolloGql';
import { GqlResponseError } from 'utils/gql/errors/GqlResponseError';
import { GqlHeaders, GqlResponse } from './gql.types';
import { isAxiosError } from './axios/axiosUtils';

export async function graphql<T>(
  query: string,
  variables = {} as any,
  options?: Partial<AxiosRequestConfig>,
  headerOptions?: GqlHeaders,
  dateHeaderOptions?: GqlHeaders,
  batch?: boolean
): Promise<GqlResponse<T>> {
  try {
    // eslint-disable-next-line @typescript-eslint/return-await
    return await apolloGql<T>(query, variables, options, headerOptions, dateHeaderOptions, undefined, batch ?? true);
  } catch (e: unknown) {
    const clientError = e as GqlResponseError;
    if (clientError.isError) {
      const status = isAxiosError(clientError)
        ? (clientError.response?.status ?? 0)
        : ((clientError as any).status ?? 0);

      if (status !== 401) captureSentryMessage(clientError.operationName, clientError);
    }
    // eslint-disable-next-line @typescript-eslint/no-throw-literal,no-throw-literal
    throw e as GqlResponseError;
  }
}

export async function graphqlAllowErrors<T>(
  query: string,
  variables = {} as any,
  options?: Partial<AxiosRequestConfig>,
  headerOptions?: GqlHeaders,
  dateHeaderOptions?: GqlHeaders
): Promise<GqlResponse<T>> {
  return apolloGql<T>(query, variables, options, headerOptions, dateHeaderOptions, true);
}
